// import configureStore from '../store'

// const store = configureStore()
const store = {}
export default store